import { PROYECTOS } from '../actions/types';

const normalize = (val) => {
    if (val === null || val === undefined) return '';
    return (val + '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
};

const initialState = {
    listado: [],
    filtrado: [],

    filtros: {
        id_cliente: '',
        nombre: '',
        status: ''
    },
    filtro_activo: false,
    detalle: null,
    loadingDetalle: false,

    resumen: null,
    listadosResumen: null,
    loadingResumen: false,

    error: null
};

export default function proyectosReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case PROYECTOS.LISTAR: {
            const listado = Array.isArray(payload) ? payload : [];
            return {
                ...state,
                listado,
                filtrado: listado,
                error: null
            };
        }

        case PROYECTOS.FILTRAR: {
            const texto = normalize(payload);
            if (!texto) {
                return { ...state, filtrado: state.listado };
            }

            const filtrado = state.listado.filter((p) => {
                const nombre = normalize(p?.nombre);
                const cliente = normalize(p?.cliente?.nombre);
                const direccion = normalize(p?.direccion);
                const descripcion = normalize(p?.descripcion);

                return (
                    nombre.includes(texto) ||
                    cliente.includes(texto) ||
                    direccion.includes(texto) ||
                    descripcion.includes(texto)
                );
            });

            return { ...state, filtrado };
        }

        case PROYECTOS.SET_FILTROS:
            return {
                ...state,
                filtros: {
                    id_cliente: payload?.id_cliente || '',
                    nombre: payload?.nombre || '',
                    status: payload?.status || ''
                },
                filtro_activo: true
            };

        case PROYECTOS.LIMPIAR_FILTROS:
            return {
                ...state,
                filtros: { ...initialState.filtros },
                filtro_activo: false
            };

        case PROYECTOS.LIMPIAR:
            return { ...initialState };

        case PROYECTOS.DETALLE_CARGANDO:
            return {
                ...state,
                detalle: null,
                loadingDetalle: true
            };

        case PROYECTOS.DETALLE:
            return {
                ...state,
                detalle: payload || null,
                loadingDetalle: false
            };

        case PROYECTOS.LIMPIAR_DETALLE:
            return {
                ...state,
                detalle: null,
                loadingDetalle: false
            };

        case PROYECTOS.RESUMEN_CARGANDO:
            return {
                ...state,
                resumen: null,
                listadosResumen: null,
                loadingResumen: true
            };

        case PROYECTOS.RESUMEN:
            return {
                ...state,
                resumen: payload?.resumen || null,
                listadosResumen: payload?.listados || null,
                loadingResumen: false
            };

        case PROYECTOS.LIMPIAR_RESUMEN:
            return {
                ...state,
                resumen: null,
                listadosResumen: null,
                loadingResumen: false
            };

        case PROYECTOS.ERROR:
            return { ...state, error: payload, loadingDetalle: false, loadingResumen: false };

        default:
            return state;
    }
}
